module.exports = __webpack_public_path__ + "img/gartek-services-electrical-be-safe.e3608c63.png";